import {SERVICE_TYPE} from '../constants/constant';
export const boolToServiceType = (value) => value ? SERVICE_TYPE.DELIVERY : SERVICE_TYPE.COLLECTION;



// WEBPACK FOOTER //
// ./helpers/formHelper.js